import * as autoBind from "auto-bind";
import * as React from "react";
import LoadObject from "../../../load_objects/LoadObject";
import { ILogin } from "../../../login/records/Login";

export interface IRevokeTokenViewProps
{
    show: boolean;
    onClose: () => void;
    revokeToken: (pwd) => void;
    loginLoader: LoadObject<ILogin>;
}

export interface IRevokeTokenViewState
{
    password: string;
}

export class RevokeTokenView extends React.PureComponent<IRevokeTokenViewProps, IRevokeTokenViewState> {

    constructor(props: any)
    {
        super(props);
        autoBind.react(this);

        this.state = {
            password: ""
        };
    }

    public render()
    {

        if (!this.props.show)
        {
            return null;
        }

        const createButtonClass = this.state.password && this.state.password !== ""
            ? "normal-button"
            : "normal-button disabled";

        return (
            <section className="lightbox-active">
                <h3>Create new token</h3>
                <section>
                    <section style={{ marginBottom: "10px" }}>
                        Are you sure you want to replace your current token with a new one? This cannot be undone.
                    </section>
                    <section style={{ marginBottom: "10px" }}>
                        Enter your password to confirm:
                    </section>

                    <label style={{ fontWeight: "bold" }}>Password <br />
                        <input style={{ marginBottom: "10px" }} autoFocus={true} type="password" value={this.state.password} onChange={this.onPasswordChanged} />
                    </label> <br />
                    <section style={{ textAlign: "left" }} className="alertBox hidden" id="alertBox"></section>
                    <a className={createButtonClass} onClick={this.revokeToken}>Revoke Token</a>
                    <a className="normal-button" onClick={this.close}>Cancel</a>

                </section>
            </section>
        );
    }

    public componentWillReceiveProps(newProps)
    {
        if (this.props.loginLoader.hasValue() &&
            newProps.loginLoader.hasValue() &&
            (this.props.loginLoader.getValue()!.token !==
                newProps.loginLoader.getValue()!.token))
        {
            this.close();
        }

        if (newProps.loginLoader.hasError())
        {
            this.showAlertBox("Incorrect password");
        }
    }

    private showAlertBox(warning)
    {
        const alertBox = document.getElementById("alertBox")!;
        if (alertBox)
        {
            alertBox.innerHTML = warning;
            alertBox.classList.remove("hidden");
        }
    }

    private onPasswordChanged(evt)
    {
        const newState = {
            password: evt.target.value
        };

        this.setState(newState);
    }

    private revokeToken()
    {
        this.props.revokeToken(this.state.password);
    }

    private close()
    {
        if (this.props.onClose)
        {
            const newState = {
                password: ""
            };

            this.setState(newState);

            this.props.onClose();
        }
    }
}
